<template>
  <div>
    <b-btn
      block
      size="sm"
      rounded
      @click="openEquipments"
      variant="secondary"
      >Adicionar ou remover Equipamentos ({{ selected.length }})
    </b-btn>

    <div class="selected-box">
      <div
        class="selected-item"
        v-for="(sel, index) in selected"
        :key="index"
      >
        {{ sel.NAME }}
      </div>
    </div>

    <PickEquipmentsModal
      v-if="showEquipmentsModal"
      v-model="showEquipmentsModal"
      :selected="selected"
      :equipments="equipments"
      :equipments-handle="equipmentsHandle"
      @selected="setSelected"
    />
  </div>
</template>

<script>
import PickEquipmentsModal from "@/common/components/PickEquipmentsModal.vue";
import EquipmentListHelper from "./EquipmentList.js";

export default {
  components: {
    PickEquipmentsModal
  },
  data() {
    return {
      equipments: [],
      showEquipmentsModal: false,
      filters: []
    }
  },
  props: {
    selected: {
      required: false,
      type: Array,
      default: () => ({})
    },
    equipmentType: {
      required: false,
      type: String,
      default: "actuator"
    },
  },
  computed: {
    equipmentsHandle() {
      return EquipmentListHelper[this.equipmentType];
    }
  },
  methods: {
    openEquipments() {
      this.showEquipmentsModal = true;
    },
    setSelected(selected) {
      this.$emit("selected", selected);
    },
  }
}
</script>